<template lang="pug">
.marketing-select-star(v-loading="loading")
  title-bar(style="margin-bottom: 20px") {{ $t('原始报价') }}
  unistar-table-container(
    v-for="(star, i) in quotationData"
    :starData="star"
    :key="i"
  )
  .section-divider
  title-bar {{ $t('确认明星') }}
  div(v-if="!selectResult || currentTask.status === '进行中'")
    template(v-if="currentTask && currentTask.can_view")
      el-row
        el-col.required(:span="4") {{ $t('明星') }}
        el-col(:span="20")
          el-radio-group(
            v-model="selectId"
          )
            .radio_container(
              style="margin-bottom: 20px;line-height: 20px"
              v-for="(item, i) in quotationData"
              :key="i"
            )
              el-radio(
                :label="item.star_id"
              ) {{ item.star_name }}
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20")
          el-input(
            v-model="remark"
            type="textarea"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error" style="margin-left:16%") {{ errors.first('remark_field') }}
      el-row
        el-col(:offset="4" :span="10")
          footer-button(
            @confirm="onConfirm"
            @cancel="$router.push('/unistar/campaign-overview')"
          )
    template(v-else)
      .no-data {{ $t('待确认') }}
  .info-display(v-else)
    el-row
      el-col(:span="24")
        .info_label {{ $t('明星') }}
        .info_content {{ selectResult.star_name }}
    el-row
      el-col(:span="24")
        .info_label {{ $t('备注') }}
        .info_content {{ selectResult.remark ? selectResult.remark : '—' }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import UnistarTableContainer from '@/components/UnistarTableContainer'
import FooterButton from '@/components/FooterButton'
import axios from 'axios'
import { format4backend } from '@/umcc/util'

export default {
  data () {
    return {
      selectId: null,
      remark: '',
      quotationData: [],
      loading: false,
      selectResult: null
    }
  },
  components: {
    TitleBar,
    UnistarTableContainer,
    FooterButton
  },
  mounted () {
    this.getStarPrice()
    this.getConfirmedStarPrice()
  },
  computed: {
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    }
  },
  methods: {
    getConfirmedStarPrice () {
      this.loading = true
      axios.get('/management/star/getConfirmedStarPrice', {
        params: {
          campaign_id: this.campaignInfo.campaign_id
        }
      })
        .then(res => {
          this.selectResult = res
          this.loading = false
        })
    },
    getStarPrice () {
      this.loading = true
      axios.get('/management/star/getStarPrice', {
        params: {
          campaign_id: this.campaignInfo.campaign_id,
          process_type: 3
        }
      })
        .then(res => {
          this.loading = false
          this.quotationData = res
        })
    },
    onConfirm () {
      this.$validator.validate().then(result => {
        if (result) {
          this.submit()
        }
      })
    },
    submit () {
      if (this.selectId == null) {
        this.$message.error(this.$t('请选择一个明星'))
        return
      }
      const params = {
        task_id: this.currentTask.taskId,
        campaign_star_choice: {
          campaign_id: this.campaignInfo.campaign_id,
          star_id: this.selectId,
          remark: this.remark
        }
      }
      this.loading = true
      axios.post('/management/star/confirmStar', format4backend(params))
        .then(res => {
          this.getConfirmedStarPrice()
          this.$store.dispatch('unistar/getProcessTasks', {
            business_key: this.campaignInfo.campaign_id,
            business_type: this.sowInfo.business_type,
            phase_type: 1
          })
          this.loading = false
          this.$message.success(this.$t('提交成功'))
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.radio_container
  height 28px
  display flex
  align-items center
.no-data
  height 300px
  display flex
  justify-content center
  align-items center
  font-size 30px
  color #e0e0e0
</style>
